import { render, staticRenderFns } from "./CouponCreation.vue?vue&type=template&id=239cc93a"
import script from "./CouponCreation.vue?vue&type=script&lang=js"
export * from "./CouponCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports